import { Component } from "react";
import { isFrontendSentryEnabled } from "../instrument";
import { reportFrontendFailure } from "../lib/monitoring";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // React 19's root error hook reports the exception to Sentry. Retain the
    // generic backend relay only as a safe fallback when the browser SDK is off.
    if (!isFrontendSentryEnabled()) {
      reportFrontendFailure();
    }
    if (process.env.NODE_ENV !== "production") {
      console.error("CleanIQ UI error boundary caught an error", error, errorInfo);
    }
  }

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <section
        className="flex min-h-[18rem] w-full items-center justify-center bg-slate-50 px-6 py-12"
        role="alert"
        aria-live="assertive"
      >
        <div className="w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl shadow-slate-900/10">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-700">CleanIQ recovery</p>
          <h1 className="mt-3 font-heading text-2xl font-extrabold text-slate-950">
            This workspace could not be displayed.
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            Your CRM data was not changed. Reload CleanIQ to retry the page safely.
          </p>
          <button
            type="button"
            onClick={this.reload}
            className="mt-6 inline-flex min-h-11 items-center justify-center rounded-xl bg-slate-950 px-5 py-3 text-sm font-bold text-white transition hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
          >
            Reload CleanIQ
          </button>
        </div>
      </section>
    );
  }
}
